import { useEffect, useRef, useState } from "react";
import { ChevronDown, Plus, Search } from "lucide-react";

// Generic searchable dropdown. options: [{ value, label, sub?, group? }]
export function SearchSelect({ options, value, onChange, placeholder = "Pilih...", testid, disabled, onCreate, createLabel = "Tambah baru", createTestid, grouped, menuUp }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const boxRef = useRef(null);
  const selected = options.find((o) => String(o.value) === String(value));
  useEffect(() => {
    const onDown = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) { setOpen(false); setQuery(""); } };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);
  const q = query.trim().toLowerCase();
  const filtered = q ? options.filter((o) => `${o.label} ${o.sub || ""}`.toLowerCase().includes(q)) : options;
  const pick = (v) => { onChange(v); setOpen(false); setQuery(""); };
  const optBtn = (o) => (
    <button type="button" key={String(o.value)} data-testid={`${testid}-opt-${o.value}`}
      className={`ss-opt ${String(o.value) === String(value) ? "ss-selected" : ""}`}
      onMouseDown={(e) => { e.preventDefault(); pick(o.value); }}>
      <span className="ss-opt-label">{o.label}</span>{o.sub ? <span className="ss-sub">{o.sub}</span> : null}
    </button>
  );
  let body;
  if (grouped) {
    const groups = [];
    filtered.forEach((o) => {
      const g = o.group || "";
      let bucket = groups.find((x) => x.g === g);
      if (!bucket) { bucket = { g, items: [] }; groups.push(bucket); }
      bucket.items.push(o);
    });
    body = groups.map((grp) => (
      <div key={grp.g || "_"} className="ss-group">
        {grp.g ? <div className="ss-group-label">{grp.g}</div> : null}
        {grp.items.map(optBtn)}
      </div>
    ));
  } else {
    body = filtered.slice(0, 100).map(optBtn);
  }
  return (
    <div className={`acct-combo ss ${disabled ? "ss-disabled" : ""}`} ref={boxRef}>
      {open && !disabled && <Search size={13} className="ss-search-icon" />}
      <input
        data-testid={testid}
        disabled={disabled}
        className={open ? "ss-open" : ""}
        placeholder={open ? "Ketik untuk mencari..." : placeholder}
        value={open ? query : selected ? selected.label : ""}
        onFocus={() => { if (!disabled) { setOpen(true); setQuery(""); } }}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Escape") { setOpen(false); setQuery(""); e.currentTarget.blur(); } }}
      />
      {!disabled && <ChevronDown size={14} className="ss-caret" onMouseDown={(e) => { e.preventDefault(); setOpen((o) => !o); setQuery(""); }} />}
      {open && !disabled && (
        <div className={`acct-combo-menu ss-menu ${menuUp ? "up" : ""}`} data-testid={`${testid}-menu`}>
          {onCreate && (
            <button type="button" className="acct-combo-add" data-testid={createTestid || `${testid}-add-new`} onMouseDown={(e) => { e.preventDefault(); onCreate(query.trim()); setOpen(false); setQuery(""); }}>
              <Plus size={13} /> {createLabel}{q ? ` "${query.trim()}"` : ""}
            </button>
          )}
          {body}
          {filtered.length === 0 && <span className="acct-combo-empty">Tidak ditemukan{onCreate ? " — gunakan tombol tambah di atas" : ""}</span>}
        </div>
      )}
    </div>
  );
}
